import { createContext, SetStateAction } from "react";
import { BakeasyConfirmDialogProp } from "../components/dialogs/BakeasyConfirmDialog";
import { BakeasyDialogProp } from "../components/dialogs/BakeasyDialog";
import { BakeasyLoaderProp } from "../components/loaders/BakeasyLoader";
import { BakeasySnackbarProp } from "../components/snackbars/BakeasySnackBar";

export interface AppContextPropTypes {
	loader: BakeasyLoaderProp;
	dialog: BakeasyDialogProp;
	setLoader: React.Dispatch<React.SetStateAction<BakeasyLoaderProp>>;
	setDialog: React.Dispatch<React.SetStateAction<BakeasyDialogProp>>;
	confirmDialog: BakeasyConfirmDialogProp;
	setConfirmDialog: React.Dispatch<
		React.SetStateAction<BakeasyConfirmDialogProp>
	>;
	setSnackbar: React.Dispatch<React.SetStateAction<BakeasySnackbarProp>>;
	snackbar: BakeasySnackbarProp;
}
export const AppContext = createContext<AppContextPropTypes>({
	dialog: {},
	loader: {},
	snackbar: {},

	setDialog: () => {},
	confirmDialog: {},
	setConfirmDialog: () => {},
	setSnackbar: () => {},
	setLoader: function (value: SetStateAction<BakeasyLoaderProp>): void {
		throw new Error("Function not implemented.");
	},
});
